import styled from 'styled-components';

const Wrap = styled.div
  .withConfig({
    shouldForwardProp: (props) => {
      return !['isScroll', 'isFill', 'isHoverExpand'].includes(props);
    },
  })
  .attrs((props) => {
    return {
      className: `${props.isFill ? '_fill' : ''} ${
        props.isScroll ? '_scroll' : ''
      } ${props.isHoverExpand ? '_hover_expand' : ''}`,
    };
  })`
  //background: rgba(54, 61, 69, 0.76);
  background-color: #323841;
  padding: 12px;
  border-radius: 4px;
  box-sizing: border-box;
  color: #fff;
  &:hover {
    z-index: 1000;
  }
  .flex-auto {
    flex: auto;
  }
  &._fill {
    display: flex;
    flex-direction: column;
  }
  &._scroll {
    padding-bottom: 0;
  }

  & + & {
    margin-top: 12px;
  }
`;

const Header = styled.div`
  height: 28px;
  line-height: 20px;
  padding-bottom: 8px;
  width: 100%;
  //background-color: #fff;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: var(--fs-md);
  justify-content: space-between;

  &:hover {
    z-index: 20;
  }
  .more {
    color: #c3c3c3;
    font-size: var(--fs-base);
    .mc-font {
      font-size: var(--fs-mdx);
    }
  }
`;

const HeaderTab = styled.div`
  height: 40px;
  margin: -12px 0 0 -12px;

  line-height: 20px;
  //background-color: #fff;
  //border-radius: 8px 8px 0 0;
  display: flex;
  align-items: center;
  .more {
    color: #c3c3c3;
    font-size: var(--fs-base);
    .mc-font {
      font-size: var(--fs-mdx);
    }
  }
`;

const HeaderTabItem = styled.div
  .withConfig({
    shouldForwardProp: (props) => {
      return !['active'].includes(props);
    },
  })
  .attrs((props) => {
    return {
      className: props.active ? 'active' : '',
    };
  })`
  //border-bottom: solid 2px transparent;

  padding: 12px 12px 8px;
  box-sizing: border-box;
  margin-right: -12px;
  height: 40px;
  font-size: var(--fs-md);
  text-align: center;
  cursor: pointer;
  color: #c3c3c3;
  position: relative;
  &:first-child {
    border-radius: 4px 0 0 0;
  }
  &:hover {
    color: #fff;
    background-color: #454d56;
  }
  &.active {
    color: #fff;
    &:after {
      position: absolute;
      content: '';
      left: 50%;
      margin-left: -7px;
      bottom: 0;
      width: 14px;
      height: 2px;
      background-color: #fff;
      border-radius: 2px;
    }
  }
`;

const Body = styled.div.withConfig({
  shouldForwardProp: (props) => {
    return !['scroll'].includes(props);
  },
})`
  flex: auto;
  margin: 0 -12px;
  padding: 0 12px;
  box-sizing: border-box;
  position: relative;
  &:hover {
    z-index: 20;
  }
  ._fill & {
    height: 20px;
  }
  ._scroll & {
    //margin-top: 8px;
    .scroll {
      height: 100%;
      margin: 0 -12px;
      padding: 0 12px;
    }
  }
  ._hover_expand &:hover {
    position: relative;
    z-index: 1;
    .scroll {
      background: rgba(54, 61, 69, 1);
      height: auto;
    }
  }
`;

export default {
  Wrap,
  Header,
  HeaderTab,
  HeaderTabItem,
  Body,
};
